import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HelperTextService } from '../../../../../core/services/helper-text.service';
import { HelpTextModel } from 'src/hub_schema/hubTypes';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { urlPattern } from '../../../../../shared/helpers/urlPattern';
import { take } from 'rxjs';

@Component({
  selector: 'app-add-helper-text-dialog',
  templateUrl: './add-helper-text-dialog.component.html',
  styleUrl: './add-helper-text-dialog.component.scss',
  standalone: false
})
export class AddHelperTextDialogComponent implements OnInit {
    private dialogRef: MatDialogRef<AddHelperTextDialogComponent> = inject(MatDialogRef<AddHelperTextDialogComponent>);
    private helperTextService: HelperTextService = inject(HelperTextService);

    public addHelperTextForm: FormGroup | undefined;
    public isSaving: boolean = false;

    public ngOnInit(): void {
        this.addHelperTextForm = new FormGroup({
            context: new FormControl('', [Validators.required, Validators.maxLength(255)]),
            label: new FormControl('', [Validators.required, Validators.maxLength(255)]),
            contentHtmlShort: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
            link: new FormControl('', [Validators.maxLength(2048), Validators.pattern(urlPattern)]),
        });
    }

    public getValidationErrorMessages(formControlName: string): string {
        const formControl = this.addHelperTextForm.get(formControlName)!;

        if (!formControl.touched) {
            return "";
        }

        const formErrors = formControl.errors;

        if (formErrors) {
            const errorMessages: string[] = [];

            for (const key of Object.keys(formErrors)) {
                if (key === "required") {
                    errorMessages.push(key);
                } else if (key === 'pattern') {
                    errorMessages.push("Invalid");
                } else {
                    console.log(key);
                    errorMessages.push(formErrors[key]);
                }
            }

            return errorMessages.join("<br />");
        }
        return "";
    }

    public cancel(): void {
        // confirmation dialog first
        this.dialogRef.close();
    }

    public save(): void {
        this.isSaving = true;
        const newHelperText: HelpTextModel = this.addHelperTextForm!.value;

        this.helperTextService.createNewHelperText(newHelperText).pipe(take(1)).subscribe((result: HelpTextModel) => {
            this.isSaving = false;
            this.dialogRef.close(result);
        });
    }

}
